import React from 'react';

import { Stack } from '@atlaskit/primitives/compiled';
import { ActivityMessage, type RelatedEventRow } from '@atlassian/audit-logs-common';

import { RelatedActivitiesRow } from './related-activities-row';

export interface OwnProps {
	relatedEvents: RelatedEventRow[];
}

export const RelatedActivitiesTable = ({ relatedEvents }: OwnProps): React.JSX.Element => {
	return (
		<Stack space="space.050">
			{relatedEvents.map((event) => (
				<RelatedActivitiesRow
					key={event.eventId}
					timestamp={event.timestamp}
					activity={<ActivityMessage activity={event.activity} />}
					avatarUrl={event.avatarUrl}
				/>
			))}
		</Stack>
	);
};
